import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { addQuestion, getQuestionById } from '../../store/questionSlice';
import EditQuestionComponent from './EditQuestionComponent';


const EditQuestionsTable = () => {


    const dispatch = useDispatch();
    const location = useLocation();
    const {questionDetails, loading } = useSelector(state => state.question)

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get("id");
        dispatch(getQuestionById(id));
    }, [dispatch, location.search]);

    if (loading || !questionDetails || Object.keys(questionDetails).length === 0) {
        return <p>Loading...</p>;
    }

    return (

        < EditQuestionComponent props={questionDetails} />

    )
}

export default EditQuestionsTable